import { Link } from "react-router-dom";
import { usePaystackPayment } from "react-paystack";
import { useState } from "react";
import Loading from "./Loading";
import { enrollmentApproved } from "../api/usersApi";
import { toast } from "react-toastify";
import payStackImg from "../assets/images/paystack.png";

const PayWithPaystackEnroll = ({
  loading,
  proceedPayment,
  handleInitPayment,
  enrollData, // { reference, email, amount }
  onPaymentSuccess,
}) => {
  const [loadingMain, setLoadingMain] = useState(false);

  const config = {
    reference: enrollData?.reference,
    email: enrollData?.email,
    amount: enrollData?.amount, // already in kobo
    publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
    currency: "NGN",
  };

  const onSuccess = (reference) => {
    handlePaymentSuccess(reference);
  };

  const handlePaymentSuccess = async (reference) => {
    setLoadingMain(true);
    try {
      const res = await enrollmentApproved(
        reference?.reference || enrollData?.reference,
      );

      if (res.data?.message !== "Enrollment payment successful") {
        toast.error("Payment verification failed, please contact support");
        return;
      }

      toast.success("Payment successful! Enrollment confirmed.");
      onPaymentSuccess(); // let parent handle redirect
    } catch (err) {
      const message =
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        err.toString();
      toast.error(message);
    } finally {
      setLoadingMain(false);
    }
  };

  const onClose = () => toast.info("Payment cancelled");

  const initializePayment = usePaystackPayment(config);

  return (
    <div className="paypalPayment">
      <div className="paypalPayment__header">
        <h4>Paystack</h4>
        <img src={payStackImg} alt="Paystack" />
        <a href="https://paystack.com" target="_blank" rel="noreferrer">
          What is Paystack?
        </a>
      </div>

      <div className="paypalPayment__info">
        Pay via Paystack; you can pay with your debit/credit card, bank
        transfer, or USSD.
      </div>

      <div className="paypalPayment__info2">
        Your personal data will be used to process your enrollment and support
        your experience. See our{" "}
        <Link to="/privacy-policy">privacy policy</Link>.
      </div>

      <div className="paypalPayment__btnCon">
        {proceedPayment ? (
          <button
            className="paypalPayment__btnCon__btn"
            onClick={() => initializePayment({ onSuccess, onClose })}
            disabled={loadingMain}
          >
            {loadingMain ? <Loading button /> : "Pay with Paystack"}
          </button>
        ) : (
          <button
            className="paypalPayment__btnCon__btn alt"
            onClick={handleInitPayment}
            disabled={loading}
          >
            {loading ? <Loading button /> : "Proceed to Payment"}
          </button>
        )}
      </div>
    </div>
  );
};

export default PayWithPaystackEnroll;
